import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ShAbstractHttpService } from '../../http/services/http.abstract.service';
import { KeyFrame } from '../entities/keyframe.entity';
import { FragmentId, MediaObjectId, RecordId } from '../entities/metadata/metadata.entity';

@Injectable({ providedIn: 'root' })
export class KeyFramesService {
    protected readonly mediaEndpoint: string = `v2/records`;

    constructor(private readonly http: ShAbstractHttpService) {}

    public getKeyFrames(recordId: FragmentId | RecordId | MediaObjectId): Observable<KeyFrame[]> {
        const request = `${this.mediaEndpoint}/${recordId}/keyframes`;
        return this.http.get<KeyFrame[]>(request);
    }
}
